import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UcpService } from '@common/services';

@Injectable()
export class KeycloakInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    request = request.clone({
      headers: UcpService.token
        ? request.headers.set('Authorization', `Bearer ${UcpService.token}`)
        : request.headers
    });
    return next.handle(request);
  }
}
